<template>
  <transition name="a-transition-fade">
    <div v-if="showComment">
      <div :class="['m-edition-asset-content-comments-item', !isChild ? 'm-edition-asset-content-comments-item-parent' : '']">
        <AtomAvatarSecondary :userImage="comment.avatar"/>
        <div class="m-edition-asset-content-comments-item-info">
          <div class="m-edition-asset-content-comments-item-info-user">
            <span class="margin-right-xsmall">
              {{ comment.nombre }}
            </span>
            <span class="font-size-small font-weight-light margin-left-auto text-color-black-65 text-transform-capitalize">
              {{ $moment(comment.fecha_alta).format('D MMMM YYYY - HH:mm') }}
            </span>
          </div>
          <p class="font-size-medium font-weight-light">
            <span v-html="comment.mensaje"></span>
          </p>

          <div class="m-edition-asset-content-comments-item-info-actions">
            <a
              v-if="$route.name === 'assets' || !isChild"
              class="margin-right-large"
              href="#"
              @click.prevent="toggleCreate"
            >
              <i :class="comentariosTipo === 1 ? 'far fa-comment' : 'far fa-reply'"></i>
              {{ comentariosTipo === 1 ? $t('mEditionAssetContentCommentsReplies.tooltip.comment') : $t('mEditionAssetContentCommentsReplies.tooltip.answer') }}
            </a>
            <a
              v-if="$route.name === 'assets' || !isChild"
              class="a-tooltip-primary a-tooltip-bottom margin-right-large"
              :data-tooltip-text="comentariosTipo === 1
              ? comment.children.length
                ? $t('mEditionAssetContentCommentsReplies.tooltip.seeComments')
                : $t('mEditionAssetContentCommentsReplies.tooltip.noComments')
              : comment.children.length
                ? $t('mEditionAssetContentCommentsReplies.tooltip.seeAnswers')
                : $t('mEditionAssetContentCommentsReplies.tooltip.noAnswers')"
              href="#"
              @click.prevent="toggleChildren"
            >
              <i :class="comentariosTipo === 1 ? 'far fa-comments' : 'far fa-reply-all'"></i>
                {{ comment.children.length }}
            </a>
            <a
              class="a-tooltip-primary a-tooltip-bottom"
              :data-tooltip-text="$t('mEditionAssetContentCommentsReplies.tooltip.like')"
              href="#"
              @click.prevent="createContenidoComentarioVoto()"
            >
              <i class="far fa-thumbs-up"></i>
                {{ comment.puntaje }}
            </a>
            <a
              v-if="actorId === comment.actor"
              class="a-tooltip-primary a-tooltip-bottom margin-left-auto"
              :data-tooltip-text="$t('mEditionAssetContentCommentsReplies.tooltip.delete')"
              href="#"
              @click.prevent="deleteContenidoComentario"
            >
              <i :class="[isDeletingComment ? 'fas fa-spinner fa-spin' : 'far fa-trash-alt', 'text-color-danger']"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="m-edition-asset-content-comments-item-child">
        <MoleculeEditionAssetContentCommentsCreate
          v-if="showCreate"
          :comentarios-tipo="comentariosTipo"
          :comment="comment"
          :contenido="contenido"
          @showReplies="showReplies"
          @toggleCreate="toggleCreate"
        />
        <div v-if="showChildren && comment.children">
          <MoleculeEditionAssetCommentsReplies
            v-for="child in comment.children"
            :key="child.id"
            :comentarios-tipo="comentariosTipo"
            :comment="child"
            :contenido="contenido"
            :is-child="true"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MoleculeEditionAssetCommentsReplies',

  components: {
    MoleculeEditionAssetContentCommentsCreate: () => import('@/components/molecules/MoleculeEditionAssetContentCommentsCreate')
  },

  props: {
    comentariosTipo: Number,
    comment: Object,
    contenido: Object,
    isChild: Boolean
  },

  data () {
    return {
      isDeletingComment: false,
      actorId: '',
      showChildren: false,
      showComment: true,
      showCreate: false
    }
  },

  created () {
    this.actorId = this.$store.getters.getActorData.id
  },

  methods: {
    createContenidoComentarioVoto () {
      this.$services.create('contenido', 'createContenidoComentarioVoto', { valor: 1 }, [this.comment.id])
        .then(response => {
          this.$modal.updateData()
        })
        .catch(error => {
          console.log(error)
        })
    },

    deleteContenidoComentario () {
      if (!this.isDeletingComment) {
        this.isDeletingComment = true
        this.$services.delete('contenido', 'deleteContenidoComentario', {}, [this.comment.id])
          .then(response => {
            this.isDeletingComment = false
            this.showComment = false
            this.$modal.updateData()
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    showReplies () {
      this.showChildren = true
    },

    toggleChildren () {
      this.showChildren = !this.showChildren
    },

    toggleCreate () {
      this.showCreate = !this.showCreate
    }
  }
}
</script>
